const UTILS = {
  ConvertStringToJS(str) {
    var script = document.createElement('script')
    script.text = str
    document.head.appendChild(script).parentNode.removeChild(script)
  },
}

document.addEventListener('alpine:init', () => {
  Alpine.data('ProductQuickAdd', () => ({
    $section: null,
    $productCard: null,
    $productForm: null,
    $variantId: null,
    product: null,
    hideSizes: true,
    selectedVariant: null, 
    mounted() {
      let am = this;
      am.$section = am.$el;
      am.$productForm = am.$section.querySelector('product-form form');
      am.$variantId = am.$productForm.querySelector('[name="id"]');
      am.$productCard = am.$section.closest('.product-card-wrapper');

      am.SetProduct();

      am.$section
        .querySelectorAll('.x-cloak-hidden')
        .forEach((item) => item.classList.remove('x-cloak-hidden'));

      document.addEventListener('cart:addtocart_complete', am.OnAddToCartComplete.bind(am));
    },
    SetProduct() {
      let am = this;
      UTILS.ConvertStringToJS(am.$section.querySelector('[data-product-json]').innerHTML);
      product.color_option = product.options_with_values.find((option) => option.name == 'Color');
      product.size_option = product.options_with_values.find((option) => option.name == 'Size');
      am.product = product;
    },
    ToggleSizes(toggle) {
      let am = this;
      am.hideSizes = !toggle;
    },
    GetSelectedVariant() {
      let am = this;
      let values = [...am.$section.querySelectorAll('input:checked')].map((item) => item.value);
      let variant = am.product.variants.find((v) => {
        return v.options.join('/') === values.join('/');
      });

      return variant;
    },
    OnAddToCartComplete() {
      let am = this;
      am.ToggleSizes(false);
    },
    e_ToggleSizes(e, toggle) {
      let am = this;
      if (am.product.variants.length == 1 || (am.product.color_option && !am.product.size_option)) {
        am.e_QuickAddToCart(e);
        return;
      }

      am.ToggleSizes(toggle);
    },
    e_QuickAddToCart(e) {
      let am = this;
      if (!am.selectedVariant) {
        console.warn('No variant selected');
        return;
      }

      if (!am.$variantId) return;
      am.$variantId.value = am.selectedVariant.id;

      if (!am.$productForm) return;
      am.$productForm.dispatchEvent(new Event('submit', { bubbles: true }));
    },
    e_VariantSelected(e) {
       let am = this
      let variant = am.GetSelectedVariant()
      if (!variant) {
        console.warn('No variant selected')
        return
      }

      if (!am.$variantId) return
      am.$variantId.value = variant.id
    }
  }))
})